import React from 'react';
import "bootstrap/dist/css/bootstrap.min.css"
import Footer from './Layout/Footer';
import Header from './Layout/Header';
import Home from './Home/Home';
import 'react-toastify/dist/ReactToastify.css';
import {ToastContainer} from "react-toastify"


function App() {
  return (
    <div>
    <Header></Header>
    <ToastContainer />
    <Home></Home><br></br><br></br>
    <Footer className="com"></Footer>
    </div>
   
  );
}

export default App;
